import Vue from "vue";
import VueRouter from "vue-router";
import { includes as _includes } from "lodash";
import HomeSection from "CivicActionCenterComponents/sections/Home.vue";
import VoterInformationSection from "CivicActionCenterComponents/sections/VoterInformation.vue";
import RegisterToVoteSection from "CivicActionCenterComponents/sections/RegisterToVote.vue";
import CandidatesSection from "CivicActionCenterComponents/sections/Candidates.vue";
import CandidateProfileSection from "CivicActionCenterComponents/sections/CandidateProfile.vue";
import ElectedOfficialsSection from "CivicActionCenterComponents/sections/ElectedOfficials.vue";
import Routes from "Constants/campaign/civicactioncenter/routeNames";
import Paths from "Constants/campaign/civicactioncenter/pathNames";
import STATE from "Constants/campaign/civicactioncenter/state";
import store from "Stores/modules/campaign/civicactioncenter/store";

Vue.use(VueRouter);

/**
 * Note: this runs *before* the CivicActionCenter component's `created` hook is run.
 * That means that even if we have an advocate in data passed from the server (e.g. via cookie)
 * then we'll still redirect to the home page away from other pages, since the store
 * doesn't get this information til after the `created` hook runs.
 *
 * To fix this, we'll need to rework how the initial state is loaded, or at least find a way
 * to read from the server-provided data instead of just the store for this check.
 */
function redirectUnlessAdvocate(redirect) {
  return function requireAdvocate(to, from, next) {
    if (store.getters[`${STATE.SCOPE_CAC}/${STATE.HAS_ADVOCATE}`]) {
      next();
    } else {
      next(redirect);
    }
  };
}

const routes = [
  {
    component: HomeSection,
    name: Routes.HOME,
    path: "/"
  },
  {
    component: CandidatesSection,
    name: Routes.CANDIDATES,
    path: `/${Paths.CANDIDATES}`
  },
  {
    component: CandidateProfileSection,
    name: Routes.CANDIDATE_PROFILE,
    path: `/${Paths.CANDIDATES}/:id`,
    meta: {
      breadcrumbs: [
        {
          textKey: "cac.app.home",
          to: { name: Routes.HOME }
        },
        {
          textKey: "cac.app.candidates",
          to: { name: Routes.CANDIDATES }
        },
        {
          type: "OFFICIAL_NAME"
        }
      ]
    },
    beforeEnter: redirectUnlessAdvocate({ name: Routes.CANDIDATES })
  },
  {
    component: ElectedOfficialsSection,
    name: Routes.ELECTED_OFFICIALS,
    path: `/${Paths.ELECTED_OFFICIALS}`
  },
  {
    component: CandidateProfileSection,
    name: Routes.OFFICIAL_PROFILE,
    path: `/${Paths.ELECTED_OFFICIALS}/:id`,
    meta: {
      breadcrumbs: [
        {
          textKey: "cac.app.home",
          to: { name: Routes.HOME }
        },
        {
          textKey: "cac.app.elected_officials",
          to: { name: Routes.ELECTED_OFFICIALS }
        },
        {
          type: "OFFICIAL_NAME"
        }
      ]
    },
    beforeEnter: redirectUnlessAdvocate({ name: Routes.ELECTED_OFFICIALS })
  },
  {
    component: VoterInformationSection,
    name: Routes.VOTER_INFORMATION,
    path: `/${Paths.VOTER_INFORMATION}`
  },
  {
    component: RegisterToVoteSection,
    name: Routes.REGISTER_TO_VOTE,
    path: `/${Paths.REGISTER_TO_VOTE}`
  },
  {
    path: "*",
    redirect: "/"
  }
];

let baseRouterPath;

const { shortUrl } = window.P2A.campaign;
const { pathname } = window.location;
if (_includes(pathname, "/embed/widget/app")) {
  baseRouterPath = `/embed/widget/app/${shortUrl}`;
} else {
  baseRouterPath = `/${shortUrl}`;
}

export default new VueRouter({
  base: baseRouterPath,
  mode: "history",
  routes
});
